// extracted by mini-css-extract-plugin
module.exports = {"DiySolarSystem":"DiySolarSystem_DiySolarSystem___4OIa"};